import React, { Component } from 'react';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../../GlobalContext';
import * as MySound from '../../MySound';

export class AdhocCount_ProductSelect extends Component {
    static displayName = AdhocCount_ProductSelect.name;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            alertMessage: "",
            products: [],
            selectedStocktake: "",
            selectedLocationId: props.location.state.selectedLocationId,
            previouspage: props.location.state.previouspage,
            selectedProductCode: "",
            selectedDesc1: "",
            selectedDesc2: "",
            selectedBarcode: "",
            selectedStocktakeLineID: "",

        };
        this.history = props.history;
    }

    componentDidMount() {

        if (!MyGlobal.selected_stocktake) {
            this.setState({ alertMessage: "Please select a Stocktake" });
            return;
        }

        var selectedStocktakeParsedData = JSON.parse(MyGlobal.selected_stocktake);
        if (selectedStocktakeParsedData) {
            this.state.selectedStocktake = selectedStocktakeParsedData;
        }

        if (!this.state.selectedStocktake.stocktakeId || this.state.selectedStocktake.stocktakeId === "") {
            this.setState({alertMessage: "Please select a Stocktake" });
            return;
        }
        this.loadProducts();

    }

    goto(page) {
        this.history.push({
            pathname: page,
            state: this.state
        });
    }


    async loadProducts() {
        this.state.loading = true;

        fetch(`api/Stocktake/GetStocktakeLinesByLocationID?stocktakeId=${this.state.selectedStocktake.stocktakeId}&locationId=${this.state.selectedLocationId}`)
            .then(async response => {

                this.state.loading = false;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    this.setState({ products: [], alertMessage: errorText });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;


                    if (apiResponse) {
                        const data = apiResponse.data;
                        if (apiResponse.success) {
                            if (data.rowItem && data.rowItem.length > 0)
                            {
                                this.setState({ products: data.rowItem, alertMessage: "" });
                            }
                            else
                            {
                                MySound.play(MySound.Sound.stop);
                                this.setState({ products: [], alertMessage: "No products found in location to count, please enter correct location or use add extra function" });
                            }
                        }
                        else {
                            this.setState({ alertMessage: "Failed to load Stock lines!!  " + apiResponse.errorMessage });
                        }
                    }
                    else {
                        this.setState({ alertMessage: "Failed to load Stock lines!!!" });
                    }
                }

            })
            .catch(error => {
                this.setState({ products: [], alertMessage: error });
            });
    }

    selectProduct(selectedRowItem) {
        this.history.push({
            pathname: 'AdhocCount_ConfirmQty',
            state: { selectedStockLine: selectedRowItem, previouspage: this.state.previouspage, selectedLocationId: this.state.selectedLocationId }
        });
    }
    render() {


        let productsHtml = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderProducts();

        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";

        return (
            <div>
                <Container>
                    <Row className="mb-3">
                        <Col xs={9}> <h5>Adhoc Count - Select Product</h5></Col>
                        <Col xs={3}><button type="button" className="btn btn-success col-12 mb-2" onClick={() => { this.goto('AdhocCount_Location'); }} >
                            Back
                        </button></Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>{alertMessage}</Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <div className="tableHolder hm-50vh mb-3">
                                {productsHtml}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

        );
    }

    renderProducts() {

        return (
            <div>
                <table className='table table-striped' aria-labelledby="tabelLabel">
                    <thead style={{ position: 'sticky', top: -2, background: 'white' }}>
                        <tr>
                            <th className="col-sm-4">
                                <label>Product</label>
                                <br />
                                <input className="col-sm-4" ref="namecodeInput" value={this.state.selectedProductCode} onChange={(e) => { this.setState({ selectedProductCode: e.target.value }); }} />
                            </th>
                            <th className="col-sm-4">
                                <label>Desc1</label>
                                <br />
                                <input className="col-sm-4" value={this.state.selectedDesc1} onChange={(e) => { this.setState({ selectedDesc1: e.target.value }); }} /> <br />
                            </th>
                            <th className="col-sm-4">
                                <label>Desc2</label>
                                <br />
                                <input className="col-sm-4" value={this.state.selectedDesc2} onChange={(e) => { this.setState({ selectedDesc2: e.target.value }); }} />
                            </th>
                            <th className="col-sm-4">
                                <label>Barcode</label>
                                <br />
                                <input className="col-sm-4" value={this.state.selectedBarcode} onChange={(e) => { this.setState({ selectedBarcode: e.target.value }); }} />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.products
                            .filter((item) =>

                                (!this.state.selectedProductCode.length ||

                                    item.productCode
                                        .toString()
                                        .toLowerCase()
                                    .includes(this.state.selectedProductCode.toString().toLowerCase())


                                ) &&
                                (!this.state.selectedDesc1.length ||

                                    item.productDescription
                                        .toString()
                                        .toLowerCase()
                                    .includes(this.state.selectedDesc1.toString().toLowerCase())
                                )
                                &&
                                (!this.state.selectedDesc2.length ||

                                    item.productDescription2
                                        .toString()
                                        .toLowerCase()
                                    .includes(this.state.selectedDesc2.toString().toLowerCase())
                                )
                                &&
                                (!this.state.selectedBarcode.length ||

                                    item.barcode
                                        .toString()
                                        .toLowerCase()
                                    .includes(this.state.selectedBarcode.toString().toLowerCase())
                                )
                                &&
                                (!this.state.selectedStocktakeLineID.length ||

                                    item.stocktakeLineID
                                        .toString()
                                        .toLowerCase()
                                    .includes(this.state.selectedStocktakeLineID.toString().toLowerCase())
                                )
                            )
                            .map(row =>
                                <tr key={row.productID + row.stocktakeLineID.trim()} onClick={() => { this.selectProduct(row) }}>
                                    <td>{row.productCode}</td>
                                    <td>{row.productDescription}</td>
                                    <td>{row.productDescription2}</td>
                                    <td>{row.barcode}</td>
                                 
                                </tr>
                            )}
                    </tbody>
                </table>
            </div>
        );
    }


}
